module.exports = __webpack_public_path__ + "static/ENmobSlide7-2745890533e3aa48539b1e10167ac1c6.jpg";